import React, { useState } from "react";
import axios from 'axios';
import { useAuthContext } from "../../../hooks/useAuthContext";

const DetailsModal = (props) => {
    const dateAdded = props.watch.inventory ? props.watch.inventory.dateAdded.slice(0,10) : 'Never added to inventory';
    const listPrice = props.watch.inventory ? `$${props.watch.inventory.listPrice}` : 'No list price';
    const brand = props.watch.brand;
    const model = props.watch.model;
    const year = props.watch.year;
    const size = props.watch.size;
    const refNum = props.watch.refNum;
    const serialNum = props.watch.serialNum;
    const condition = props.watch.condition;
    const box = props.watch.box;
    const papers = props.watch.papers;
    const notes = props.watch.notes;
    // const status = props.watch.status;
    const purDate = props.watch.purOrder.purDate;
    const supplier = props.watch.purOrder.supplier;
    const purStatus = props.watch.purOrder.purStatus;
    const purPrice = props.watch.purOrder.purPrice;
    const purNotes = props.watch.purOrder.purNotes;
    const saleDate = props.watch.saleOrder.saleDate;
    const salePrice = props.watch.saleOrder.salePrice;
    const saleCustomer = props.watch.saleOrder.saleCustomer;
    const shipToStreet = props.watch.saleOrder.shipToStreet;
    const shipToCity = props.watch.saleOrder.shipToCity;
    const shipToState = props.watch.saleOrder.shipToState;
    const shipToZip = props.watch.saleOrder.shipToZip;
    const saleNotes = props.watch.saleOrder.saleNotes;
    const invoiced = props.watch.saleOrder.invoiced;
    const shipped = props.watch.saleOrder.shipped;
    const delivered = props.watch.saleOrder.delivered;
    const [error, setError] = useState(null);
    const {user} = useAuthContext(); //grabbing the user object that is returned from the useAuthContext hook
    


    const createInvoice = async (event) => {
        event.preventDefault();

        const request = {
            brand, model, year, saleDate: saleDate.slice(0,10), salePrice, saleCustomer, 
            shipToStreet, shipToCity, shipToState, shipToZip, userId: user.userId
        }

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_SERVER_URL}/api/invoice/create-invoice`,
                request,
                {
                    responseType: 'blob',
                    headers: {'Authorization': `Bearer ${user.token}`}
                }
            )

            const file = new Blob([response.data], { type: 'application/pdf' });

            // Create a URL for the Blob
            const url = window.URL.createObjectURL(file);

            // Optionally, open in a new window
            const newWindow = window.open(url);
            // if (newWindow) {
            //     newWindow.document.write('<iframe width="100%" height="100%" src="' + url + '"></iframe>');
            // }
            
            // Trigger a download using a temporary anchor tag
            // const link = document.createElement("a");
            // link.href = url;
            // link.download = "generated.pdf"; // Name of the file
            // link.click();
            
            // // Clean up the URL object after usage
            // window.URL.revokeObjectURL(url);

        } catch (error) {
            setError(error.message);
        }
    }




    return (
        <div className="details-modal-container">

            <div className="details-container">
                <div className="inner-form-container">
                    <label>Brand</label>
                    <p>{brand}</p>
                </div>
                <div className="inner-form-container">
                    <label>Model</label>
                    <p>{model}</p>
                </div>
                <div className="inner-form-container">
                    <label>Year</label>
                    <p>{year}</p>
                </div>
                <div className="inner-form-container">
                    <label>Size</label>
                    <p>{size}</p>
                </div>
                <div className="inner-form-container">
                    <label>Reference Number</label>
                    <p>{refNum}</p>
                </div>
                <div className="inner-form-container">
                    <label>Serial Number</label>
                    <p>{serialNum}</p>
                </div>
                <div className="inner-form-container">
                    <label>Condition</label>
                    <p>{condition}</p>
                </div>
                <div className="inner-form-container">
                    <label>Box</label>
                    <p>{box === true ? "Yes" : "No"}</p>
                </div>
                <div className="inner-form-container">
                    <label>Papers</label>
                    <p>{papers === true ? "Yes" : "No"}</p>
                </div>
                <div className="inner-form-container">
                    <label>Watch Notes</label>
                    <p>{notes}</p>
                </div>
            </div>

            <h3>Sale Order Details</h3>
            <div className="details-container">
                <div className="inner-form-container">
                    <label>Sale Date</label>
                    <p>{saleDate.slice(0,10)}</p>
                </div>
                <div className="inner-form-container">
                    <label>Sale Price</label>
                    <p>${salePrice}</p>
                </div>
                <div className="inner-form-container">
                    <label>Sale Customer</label>
                    <p>{saleCustomer}</p>
                </div>
                <div className="inner-form-container">
                    <label>Ship To Address</label>
                    <p>{shipToStreet}</p>
                    <p>{shipToCity}, {shipToState}</p>
                    <p>{shipToZip}</p>
                </div>
                <div className="inner-form-container">
                    <label>Invoiced</label>
                    <p>{invoiced === true ? "Yes" : "No"}</p>
                </div>
                <div className="inner-form-container">
                    <label>Shipped</label>
                    <p>{shipped === true ? "Yes" : "No"}</p>
                </div>
                <div className="inner-form-container">
                    <label>Delivered</label>
                    <p>{delivered === true ? "Yes" : "No"}</p>
                </div>
                <div className="inner-form-container">
                    <label>Sale Notes</label>
                    <p>{saleNotes}</p>
                </div>
            </div>

            <h3>Purchase Details</h3>
            <div className="details-container">
                <div className="inner-form-container">
                    <label>Purchase Date</label>
                    <p>{purDate.slice(0,10)}</p>
                </div>
                <div className="inner-form-container">
                    <label>Purchase Price</label>
                    <p>${purPrice}</p>
                </div>
                <div className="inner-form-container">
                    <label>Supplier</label>
                    <p>{supplier}</p>
                </div>
                <div className="inner-form-container">
                    <label>Purchase Status</label>
                    <p>{purStatus}</p>
                </div>
                <div className="inner-form-container">
                    <label>Purchase Notes</label>
                    <p>{purNotes}</p>
                </div>
            </div>

            <h3>Inventory Details</h3>
            <div className="details-container">
                <div className="inner-form-container">
                    <label>Date Added</label>
                    <p>{dateAdded}</p>
                </div>
                <div className="inner-form-container">
                    <label>List Price</label>
                    <p>{listPrice}</p>
                </div>
            </div>

            {/* Generate Invoice Button */}
            <button 
            className="invoice-btn btn btn-light" 
            onClick={createInvoice}
            >
                Create Invoice
            </button>
            {error && <div className="error">{error}</div>}
        </div>
    )
}

export default DetailsModal